<template>
  <div class="verificatioin" v-bind="$attrs">
    <Input
      maxlength="4"
      placeholder="图片验证码"
      number
      :name="name"
      :value="code"
      :error="error"
      @input="handleChange"
      class="verificatioin__code"
      ref="code"
      @blur="handleBlur"
    />
    <span class="verificatioin__image">
      <img :src="codeUrl" @click="refreshImgCode">
    </span>
  </div>
</template>
<script>
import Countdown from '@/components/Countdown';
import Input from '@/components/Input';
import { genarateRandomString } from '@/utils';
import env from '@/utils/env.js'
const host = env.getHost();
export default {
  name: 'verification-code',
  data() {
    return {
      code: '',
      baseUrl: `${host}/api/v2/randCode`,
      randomCode: '',
    };
  },
  methods: {
    handleChange(value) {
      this.code = value;
      this.$emit('input', this.code);
    },
    refreshImgCode() {
      this.randomCode = genarateRandomString();
      this.$emit('updateKey', this.randomCode);
    },
    focus() {
      this.$refs.code.focus();
    },
    handleBlur(value) {
      this.$emit('blur', value);
    }
  },
  mounted() {
    this.refreshImgCode();
  },
  computed: {
    codeUrl() {
      return `${this.baseUrl}?key=${this.randomCode}`;
    }
  },
  watch: {
    value(val) {
      this.code = val;
    }
  },
  components: {
    Countdown,
    Input
  },
  props: {
    name: String,
    value: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    number: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.verificatioin {
  position: relative;
  &__image {
    position: absolute;
    top: 6px;
    right: 0;
    width: 100px;
    height: 28px;
    > img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>